<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('代理商名称')" prop="agentName">
                <a-input v-model="queryParam.agentName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('代理商名称')" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('统一社会信用码')" prop="socialCreditCode">
                <a-input v-model="queryParam.socialCreditCode" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('统一社会信用码')" allow-clear/>
              </a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('法人名称')" prop="legalPersonName">
                  <a-input v-model="queryParam.legalPersonName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('法人名称')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('法人身份证号')" prop="legalPersonIdCard">
                  <a-input v-model="queryParam.legalPersonIdCard" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('法人身份证号')" allow-clear/>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('法人手机')" prop="legalPersonPhone">
                  <a-input v-model="queryParam.legalPersonPhone" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('法人手机')" allow-clear/>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('法人证件号')" prop="legalPersonDocumentNumber">
                  <a-input v-model="queryParam.legalPersonDocumentNumber" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('法人证件号')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('代理申请日期')" prop="applicationDate">
                  <a-date-picker style="width: 100%" v-model="queryParam.applicationDate" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商城关联账号')" prop="mallAccount">
                  <a-input v-model="queryParam.mallAccount" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('商城关联账号')" allow-clear/>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('物联关联账号')" prop="iotAccount">
                  <a-input v-model="queryParam.iotAccount" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('物联关联账号')" allow-clear/>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('联系方式')" prop="contactNumber">
                  <a-input v-model="queryParam.contactNumber" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('联系方式')" allow-clear/>
                </a-form-item>
              </a-col>



            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('通用.按钮.收起') : $t('通用.按钮.展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
       <!--  <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:agents:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:agents:edit']">
          <a-icon type="edit" />{{$t('通用.按钮.修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:agents:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button> -->
        <a-button type="primary" @click="handleExport" v-hasPermi="['user:agents:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
          :statusOptions="dict.type.user_cancel_status"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="applicationDate" slot-scope="text, record">
          {{ parseTime(record.applicationDate) }}
        </span>
        <span slot="reviewTime" slot-scope="text, record">
          {{ parseTime(record.reviewTime) }}
        </span>
        <span slot="reviewStatus" slot-scope="text, record">
                  <!-- 1：未审核 2：审核通过 3：审核不通过-->
                  <a-tag color="blue" v-if="record.reviewStatus === 1">待审核</a-tag>
                  <a-tag  color="#87d068" v-if="record.reviewStatus === 2">审核通过
                <!--     <a-tooltip effect="dark" :title="record.reviewStatus" placement="right">
                      !
                    </a-tooltip> -->
                  </a-tag>
                  <a-tag color="#f50" v-if="record.reviewStatus===3">审核驳回
                  <!--   <a-tooltip effect="dark" :title="record.reviewStatus" placement="right">
                      !
                    </a-tooltip> -->
                  </a-tag>
                </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:agents:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:agents:edit']">
             <a-icon type="edit" />{{$t('通用.按钮.审核')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['user:agents:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:agents:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageAgents,listAgents, delAgents } from '@/api/user/agents'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Agents',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['user_cancel_status'],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        agentName: undefined,
        socialCreditCode: undefined,
        legalPersonName: undefined,
        legalPersonIdCard: undefined,
        legalPersonPhone: undefined,
        legalPersonDocumentNumber: undefined,
        applicationDate: undefined,
        registeredAddress: undefined,
        mallAccount: undefined,
        iotAccount: undefined,
        contactNumber: undefined,
        contactAddress: undefined,
        detailedAddress: undefined,
        cooperationNotes: undefined,
        reviewStatus: undefined,
        reviewer: undefined,
        reviewTime: undefined,
        reasonDesc: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        /* {
          title: this.$t('主键ID'),
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        }, */
        {
          title: this.$t('用户昵称'),
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center'
        },

        {
          title: this.$t('代理商'),
          dataIndex: 'agentName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('统一社会信用码'),
          dataIndex: 'socialCreditCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('法人'),
          dataIndex: 'legalPersonName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('法人身份证号'),
          dataIndex: 'legalPersonIdCard',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('法人手机'),
          dataIndex: 'legalPersonPhone',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('法人证件号'),
          dataIndex: 'legalPersonDocumentNumber',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('申请日期'),
          dataIndex: 'applicationDate',
          scopedSlots: { customRender: 'applicationDate' },
          ellipsis: true,
          align: 'center'
        },
      /*   {
          title: this.$t('注册地址'),
          dataIndex: 'registeredAddress',
          ellipsis: true,
          align: 'center'
        }, */
        // {
        //   title: this.$t('商城账号'),
        //   dataIndex: 'mallAccount',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('物联账号'),
        //   dataIndex: 'iotAccount',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('联系方式'),
          dataIndex: 'contactNumber',
          ellipsis: true,
          align: 'center'
        },
    /*     {
          title: this.$t('联系地址'),
          dataIndex: 'contactAddress',
          ellipsis: true,
          align: 'center'
        }, */
    /*     {
          title: this.$t('详细地址'),
          dataIndex: 'detailedAddress',
          ellipsis: true,
          align: 'center'
        }, */
   /*      {
          title: this.$t('合作备注'),
          dataIndex: 'cooperationNotes',
          ellipsis: true,
          align: 'center'
        }, */
        {
          title: '审核状态',
          dataIndex: 'reviewStatus',
          align: 'center',
          scopedSlots: {customRender: 'reviewStatus'},
        },
       /*  {
          title: this.$t('审核状态'),
          dataIndex: 'reviewStatus',
          ellipsis: true,
          align: 'center'
        }, */
       /*  {
          title: this.$t('审核人'),
          dataIndex: 'reviewer',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('审核时间'),
          dataIndex: 'reviewTime',
          scopedSlots: { customRender: 'reviewTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('原因说明'),
          dataIndex: 'reasonDesc',
          ellipsis: true,
          align: 'center'
        }, */
      /*   {
          title: this.$t('备注'),
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        }, */
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询代理商列表 */
    getList () {
      this.loading = true
     pageAgents(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        agentName: undefined,
        socialCreditCode: undefined,
        legalPersonName: undefined,
        legalPersonIdCard: undefined,
        legalPersonPhone: undefined,
        legalPersonDocumentNumber: undefined,
        applicationDate: undefined,
        registeredAddress: undefined,
        mallAccount: undefined,
        iotAccount: undefined,
        contactNumber: undefined,
        contactAddress: undefined,
        detailedAddress: undefined,
        cooperationNotes: undefined,
        reviewStatus: undefined,
        reviewer: undefined,
        reviewTime: undefined,
        reasonDesc: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delAgents(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('user/agents/export',
            ...that.queryParam
          , `代理商_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
